import React,{useEffect,useState} from 'react';
import {Container,Row,Col,Table} from 'react-bootstrap';
import './index.scss';
import { Link } from "react-router-dom";
import Button  from "../../common/Button";
import axios from 'axios'
import {APIurl} from '../../App';
import TableUser from '../../components/TableUser'
import MSGDialogue from '../../components/Dialogue';

function DashCards(props){
    return (
        <>
        <div className="stats-card bg-white box-hover transition-all-1s animate__animated animate__fadeInDown">
            <div className="stats-title mb-4">{props.title}</div>
           
          <div className="stats-content d-flex  flex-row">
            <div className='theme-color font-weight-bold m-1 stats-icon'>
           <i className="fa fa-line-chart"></i>
            </div>
            <div className='stat-nums m-1'><b>{props.number}</b></div>
            <div className='stats-bar m-1'></div>

          </div>
        </div>
        </>
    );
}

export default function Keys(){

  const [members,setMember] = useState([]);
  const [loginmsg, setLogingmsg] = useState("");
  const [colors, setColors] = useState("");
  const [totalMembers, setTotalMembers] = useState("0");
  const [freelancer, setFreelancer] = useState("0");
  const [LTOA, setLTOA] = useState("0");
  const [logging, setLogging] = useState(false);
  const [diaglogueID, setdiaglogueID] = useState("msg13");
  
useEffect(() => {
  axios.post(APIurl, {
    cmd: "getallkeys",
    email: localStorage.getItem("email"),
    userType: localStorage.getItem("userType")
  })
  .then((response) => {
    const res = response.data;

    if (!res.success) {
      setLogingmsg(res.data);
      setColors("bg-danger text-white");
    } else {
      setMember(res.data);
      setTotalMembers(res.data.length);
      setColors("bg-success text-white");
    }

    setLogging(true);
  })
  .catch(() => {
    setLogingmsg("Could not load License Keys");
    setColors("bg-danger text-white");
    setLogging(true);
  });
}, []);

    

  const Cards = [
  { id: 1, title: 'Total Keys', number: totalMembers },
  { id: 3, title: 'Total Clients', number: LTOA }
];

  var table_headers = [
  { id: 1, name: "ID" },
  { id: 2, name: "Email" },
  { id: 3, name: "Mentor" },
  { id: 4, name: "License Key" } ,
  { id: 5, name: "Manage" }
];

    var buttons = [{id:1,title:"Export CSV",path:"exportmembers"},{id:2,title:"Create Key",path:"addkey"}]

    return (
        <>
         {logging? <MSGDialogue msg = {loginmsg} id = {diaglogueID}  colors= {colors} /> : ""} 
       <div className='mr-0 ml-0 p-2 mt-2 mb-0'><h3>License Keys</h3></div>
       <Container fluid className='d-flex flex-row mt-2 w-100 home-cards'>

       {Cards.map((card) => <DashCards key={card.id} title={card.title} number ={card.number}  />)}
       
       </Container>
      <TableUser  name="License Keys" copy="/copy" delete="/memberdelete" table_headers = {table_headers} members={members} buttons={buttons}/>
        </>
    );
}

